"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MINIMUM_REVIEWS_REQUIRED_TO_DISPLAY = void 0;
var MINIMUM_REVIEWS_REQUIRED_TO_DISPLAY = 3;
exports.MINIMUM_REVIEWS_REQUIRED_TO_DISPLAY = MINIMUM_REVIEWS_REQUIRED_TO_DISPLAY;